import styled from "styled-components";

export const SatelliteChamberListingRow = styled.div`
    display: grid;
    grid-template-columns: 1fr 0.75fr 0.75fr 0.5fr;
    border-bottom: 1px solid #000;
    ${props => props?.isFirstRow && 'border-top: 1px solid #000'};
    padding: 4px 0;
`